"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalAppDownloadDisplayState = exports.HilPreQualAmountSource = exports.AddressValidationErrorCode = exports.PortalPhoneVerificationError = void 0;
var PortalPhoneVerificationError;
(function (PortalPhoneVerificationError) {
    PortalPhoneVerificationError["INCORRECT_CODE"] = "INCORRECT_CODE";
    PortalPhoneVerificationError["TWILIO_ERROR"] = "TWILIO_ERROR";
    /**
     * Source of truth for this code on the wire. `INVALID_US_PHONE_NUMBER_ERROR` in
     * aven_backend/src/util/errorCodes.ts re-exports this member rather than repeating the string.
     * The `_ERROR` suffix is retained in the value because existing backend callers already emit it.
     */
    PortalPhoneVerificationError["INVALID_US_PHONE_NUMBER"] = "INVALID_US_PHONE_NUMBER_ERROR";
})(PortalPhoneVerificationError || (exports.PortalPhoneVerificationError = PortalPhoneVerificationError = {}));
var AddressValidationErrorCode;
(function (AddressValidationErrorCode) {
    AddressValidationErrorCode["AMBIGUOUS_PROPERTY_ADDRESS"] = "AMBIGUOUS_PROPERTY_ADDRESS_ERROR";
    AddressValidationErrorCode["PROPERTY_MISSING_UNIT_NUMBER"] = "PROPERTY_ADDRESS_MISSING_UNIT_NUMBER";
    AddressValidationErrorCode["AMBIGUOUS_PRIMARY_ADDRESS"] = "AMBIGUOUS_PRIMARY_ADDRESS_ERROR";
    AddressValidationErrorCode["PRIMARY_MISSING_UNIT_NUMBER"] = "PRIMARY_ADDRESS_MISSING_UNIT_NUMBER";
    AddressValidationErrorCode["ADDRESS_NOT_FOUND"] = "ADDRESS_NOT_FOUND_ERROR";
    AddressValidationErrorCode["ADDRESS_NOT_SUPPORTED"] = "ADDRESS_NOT_SUPPORTED_ERROR";
    // Distinct from ADDRESS_NOT_SUPPORTED, which enrolls the applicant in the waitlist.
    AddressValidationErrorCode["PROPERTY_STATE_NOT_ELIGIBLE_FOR_CHANNEL"] = "PROPERTY_STATE_NOT_ELIGIBLE_FOR_CHANNEL_ERROR";
    AddressValidationErrorCode["INVALID_ADDRESS"] = "INVALID_ADDRESS_ERROR";
    AddressValidationErrorCode["ADDRESS_VALIDATION_API_ERROR"] = "ADDRESS_VALIDATION_API_ERROR";
    AddressValidationErrorCode["NOO_PROPERTY_AND_PERSONAL_ADDRESS_MATCH"] = "NOO_PROPERTY_AND_PERSONAL_ADDRESS_MATCH_ERROR";
})(AddressValidationErrorCode || (exports.AddressValidationErrorCode = AddressValidationErrorCode = {}));
var HilPreQualAmountSource;
(function (HilPreQualAmountSource) {
    HilPreQualAmountSource["EstimatedInvoiceAmount"] = "EstimatedInvoiceAmount";
    HilPreQualAmountSource["PreQualOptionLineSize"] = "PreQualOptionLineSize";
    HilPreQualAmountSource["EqualInvoiceAndLineSize"] = "EqualInvoiceAndLineSize";
})(HilPreQualAmountSource || (exports.HilPreQualAmountSource = HilPreQualAmountSource = {}));
var PortalAppDownloadDisplayState;
(function (PortalAppDownloadDisplayState) {
    /** Show the "All set! Download the Aven app" UI. Reached for non-UCC (home) LAs and UCC LAs whose credit card account was created. */
    PortalAppDownloadDisplayState["downloadApp"] = "downloadApp";
    /** Show the "We're reviewing your application" UI. Reached for UCC LAs where account creation was blocked */
    PortalAppDownloadDisplayState["underReview"] = "underReview";
})(PortalAppDownloadDisplayState || (exports.PortalAppDownloadDisplayState = PortalAppDownloadDisplayState = {}));
